export default __webpack_public_path__ + "static/thomas-mader-caeb99d27b52607eeaf2ecaa29d0fef6.jpg";